import { JSONSchema7 } from "json-schema";
export const ProductInputSchema = {
    label: "Product Picker",
    uiSchema: {
        paragraph: {
            "ui:widget": "textarea"
        },
        // Notice here we change the ui component from the generic quickform to our customer specific component -> ../Designer/ButtonsOptionsField
        productId: {
            "ui:field": "ProductLookupField",            
        },
        options: {
            "ui:widget":"hidden"
        },        
        imagesPerRowControl: {
            "ui:field": "ImagesPerRowField"
        },
    },
    schema: {
        type: "object",

        properties: {
            text: {
                title: "Text",
                type: "string"
            },
            productId: {
                type: "string",
            },
            options: {
                type: "object",
            },
            imagesPerRowControl: {
                title: "Options for buttons with images",
                type: "object",
                properties: {
                    customImagesPerRow: { type: "boolean" },
                    imagesPerRowDesktop: { type: "integer", minimum: 1, maximum: 20, default: 8 },
                    imagesPerRowTablet: { type: "integer", minimum: 1, maximum: 16, default: 4 },
                    imagesPerRowPhone: { type: "integer", minimum: 1, maximum: 16, default: 2 }
                }
            },
        }
    } as JSONSchema7
}